import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/announce/:trackingNumber(\\d{10})',
    name: 'Announce By TN',
    component: () => import('@/views/Announce.vue')
  },
  {
    path: '/announce/exportReference/:exportReference(\\d{4}-?\\d{4}-?\\d{3}\\.?\\d{3})',
    name: 'Announce by Export Reference',
    component: () => import('@/views/Announce.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
